import { InjectionToken } from '@angular/core';

/**
 * Activa el modo Envio simple en los componentes reutilizados de configuracion de
 * documento (panel de firmantes, tipo de firma, gadgets). Se provee como `true`
 * en la pagina Firmantes de Envio simple; en el wizard estandar no se provee
 * (los componentes lo inyectan con `@Optional()` y por defecto se comportan como hoy).
 */
export const MODO_ENVIO_SIMPLE = new InjectionToken<boolean>('MODO_ENVIO_SIMPLE');
